import React from 'react';
import { _ } from '../../../functions/translator';

class StartInfo extends React.Component{

    render(){

        let startValue = this.props.cardsGroup.attributes.start;
        let startDefinition = _("Inicio");

        if (this.props.customcard) {
            if (!this.props.customcard.attributes.start) return <div></div>;
            startDefinition = this.props.customcard.attributes.start;
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ startDefinition }</p>
                <span className='text card-description'>{ startValue }</span>
            </div>
        );
    }
}

export default StartInfo;